import { useLayoutContext } from '../../../Context/Layout.context';
import { createMovie } from '../../../services/supportMovie/supportMovie.service';
import { MovieEditor } from '../MovieEditor/MovieEditor.component';

interface MovieProps {
  onClose: () => void;
  onChange: () => void;
}

export const MovieAdd: React.FC<MovieProps> = ({ onClose, onChange }) => {
  const handleClose = () => {
    onClose();
  };

  const { openAlert } = useLayoutContext();

  const handleSave = (title: string, description: string, url: string) => {
    createMovie(title, description, url).then(
      () => {
        openAlert('success');
        onClose();
        onChange();
      },
      () => {
        openAlert('save_error');
      },
    );
  };
  return (
    <MovieEditor
      title="Dodaj film"
      onCancel={handleClose}
      onSave={handleSave}
      onChange={onChange}
      movieTitle={''}
      movieDescription={''}
      movieUrl={''}
      movieId={''}
    />
  );
};
